import { PageTitle } from "@/components/admin/kit";
import { HelpSections, useHelp } from "@/components/admin/HelpBox";
import { useTerms } from "@/lib/industry";

const ORDER = ["houseTypes", "setup", "editor", "cinematic", "realtors", "developments", "finishes", "skin", "assistant", "leads", "analytics", "settings"];

export default function AdminHelp() {
  const HELP = useHelp();
  const { t } = useTerms();
  const order = ORDER.filter((k) => HELP[k]);
  return (
    <div data-testid="admin-help-page">
      <PageTitle title="Help & guide" sub={`How every part of the ${t.portal.toLowerCase()} works.`} />
      <nav className="flex flex-wrap gap-2 mb-8">
        {order.map((k) => <a key={k} href={`#help-${k}`} className="h-9 px-4 rounded-full border bg-white text-sm inline-flex items-center hover:bg-slate-50" data-testid={`help-jump-${k}`}>{HELP[k].title}</a>)}
      </nav>
      <div className="space-y-6">
        {order.map((k) => (
          <section key={k} id={`help-${k}`} className="rounded-3xl bg-white border p-6 sm:p-8 scroll-mt-6" data-testid={`help-section-${k}`}>
            <h2 className="font-serif text-2xl mb-4">{HELP[k].title}</h2>
            <HelpSections topic={k} />
          </section>
        ))}
      </div>
    </div>
  );
}
